import type { ReactNode } from 'react';
import { AxiosErrorHandler, Flex, Loading, Title } from 'ui';
import { images } from 'common/utils';
import type { PublicCommunityDataObject } from 'models/service';
import { useCommunityPublicQuery } from '../queries';

type P = {
  children: (data: PublicCommunityDataObject) => ReactNode;
  communityId: string;
};

const PublicCommunityLayout = ({ children, communityId }: P) => {
  const { data, error, isLoading } = useCommunityPublicQuery({ communityId });

  return (
    <AxiosErrorHandler error={error}>
      {isLoading || !data ? (
        <Loading />
      ) : (
        <div className="public-community-layout">
          <div className="public-community-layout__header">
            <img alt={data.name} src={data.cover_photo?.url ?? images.default.communityCoverPhoto} />
          </div>
          <div className="public-community-layout__title">
            <Flex align="center" justify="center">
              <Title level={2}>{data.name}</Title>
            </Flex>
          </div>
          {children(data)}
        </div>
      )}
    </AxiosErrorHandler>
  );
};

export default PublicCommunityLayout;
